import cryptojs from "@/Common/cryptojs.js"
let _vue = null
function init(vue) {
  _vue = vue;
}

const keys = { userInfo: 'userInfo', menu: 'lastMenu', UUID: 'UUID', api: 'api', role: 'role' }

function getUserInfo() {//03月16日调整，不用获取用户信息 
  let userInfo = localStorage.getItem(keys.userInfo);
  if (userInfo) {
    try {
      userInfo = JSON.parse(userInfo);
    } catch (err) {
      userInfo = null;
    }
  }
  return userInfo;
}

function setUserInfo(data) {//设置用户信息（登录成功）
  localStorage.setItem(keys.userInfo, JSON.stringify(data.UserInfo));
  localStorage.setItem(keys.api, data.Apis);
  localStorage.setItem(keys.role, data.Roles);
}

function SetUUID(data) {//设置uuid
  localStorage.setItem(keys.UUID, data);
}

function GetUUID() {//获取uuid
  return localStorage.getItem(keys.UUID);
}

function clearUserInfo() {//清除用户信息（退出登录）
  localStorage.removeItem(keys.userInfo);
}

function getToken() {//获取token
  let u = getUserInfo();
  if (u) {
    return u.Token;
  }
  return '';
}

function setLastMenu(data) {//设置最后一次跳转的菜单
  localStorage.setItem(keys.menu, JSON.stringify(data));
}

function getLastMenu() {//获取最后一次跳转的菜单
  let Menu = localStorage.getItem(keys.menu);
  if (Menu) {
    try {
      Menu = JSON.parse(Menu);
    } catch (err) {
      Menu = null;
    }
  }
  return Menu;
}

function ApiAuthorize(apiUrl) {//接口是否授权
  let Apis = localStorage.getItem(keys.api);
  // Apis = Apis.replace(/[\n]/g, '')
  let apistr = cryptojs.decrypt(GetUUID(), Apis)
  let apiArr = JSON.parse(JSON.parse(apistr));
  let ret = false;
  if (apiArr != null && apiArr.length > 0) {
    for (let index = 0; index < apiArr.length; index++) {
      let api = apiArr[index];
      api = api.toLowerCase();
      let aApiArr = apiUrl.split('/');
      if (aApiArr.length >= 2) {
        apiUrl = aApiArr[aApiArr.length - 2] + '/' + aApiArr[aApiArr.length - 1];
        if (api.indexOf(apiUrl.toLowerCase()) > -1) {
          ret = true;
        }
      }
    }
  }
  return ret;
}

function IsRole(role) {//是否这个角色
  let rolestr = localStorage.getItem(keys.role);
   rolestr = cryptojs.decrypt(GetUUID(), rolestr)
  let roleArr = JSON.parse(JSON.parse(rolestr));
  let ret = false;
  if (roleArr != null && roleArr.length>0) {
    for (let index = 0; index < roleArr.length.length; index++) {
      const api = roleArr[index];
      if (role == api) {
        ret = true;
      }
    }
  }
  return ret;
}

function clearMenu() {//清除最后一次跳转的菜单
  localStorage.removeItem(keys.menu);
}

export default { getUserInfo, setUserInfo, clearUserInfo, getToken, init, setLastMenu, getLastMenu, clearMenu, SetUUID, GetUUID, ApiAuthorize, IsRole };



// WEBPACK FOOTER //
// ./src/Common/UserInfo.js